import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_arrow",
  "use": "dashboard_card_icon_menu_arrow-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_arrow\"><g fill=\"#2D2C34\"><path d=\"M17.827 1.519a.531.531 0 0 1 .65.65l-2.144 8.003a.531.531 0 0 1-.889.239L9.586 4.552a.531.531 0 0 1 .238-.889l8.003-2.144Z\" /><path d=\"M.793 17.79a1 1 0 0 0 1.414 1.414L.793 17.789Zm1.414 1.414L14.674 6.737 13.26 5.323.793 17.789l1.414 1.415Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol